// extracted by mini-css-extract-plugin
export var activeDot = "_42-c";
export var buttonContainer = "_42-9";
export var channelButton = "_42-a";
export var clickable = "_42-d";
export var content = "_42-0";
export var contentFull = "_42-2";
export var contentThird = "_42-1";
export var contentWrapper = "_42-7";
export var description = "_42-5";
export var heightShort = "_42-f";
export var image = "_42-3";
export var imageContainer = "_42-4";
export var selectButton = "_42-e";
export var spinnerContainer = "_42-b";
export var titleContent = "_42-8";
export var titleWrapper = "_42-6";